import { render, staticRenderFns } from "./redesSociales.vue?vue&type=template&id=4e9732bf&scoped=true&"
import script from "./redesSociales.vue?vue&type=script&lang=js&"
export * from "./redesSociales.vue?vue&type=script&lang=js&"
import style0 from "./redesSociales.vue?vue&type=style&index=0&id=4e9732bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9732bf",
  null
  
)

export default component.exports